import { useLocation } from "react-router-dom";
import styled from 'styled-components'
import { Link } from "react-router-dom";

export default function CustomerNavigation({ }) {
    const location = useLocation();

    const getCurrentPage = () => {
        if (location.pathname.includes('/status')) return 'status';
        if (location.pathname.includes('/trends')) return 'trends';
        if (location.pathname.includes('/complaint')) return 'complaint';
        return ''; // 기본값
    };

    const currentPage = getCurrentPage();

    const navItems = [
        { id: "status", label: "Status", href: "/customer/status" },
        { id: "trends", label: "Trends", href: "/customer/trends" },
        { id: "complaint", label: "Complaint", href: "/customer/complaint" },
    ]

    const CalendarIcon = ({ active }) => (
        <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke={active ? "#0072B9" : "#6B7280"}
            strokeWidth={active ? "2.5" : "2"}
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    )

    const TrendingUpIcon = ({ active }) => (
        <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke={active ? "#0072B9" : "#6B7280"}
            strokeWidth={active ? "2.5" : "2"}
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
            <polyline points="17 6 23 6 23 12" />
        </svg>
    )

    const MailIcon = ({ active }) => (
        <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke={active ? "#0072B9" : "#6B7280"}
            strokeWidth={active ? "2.5" : "2"}
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* 편지 봉투 몸체 */}
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
            {/* 편지 접힘 부분 (V자 모양) */}
            <polyline points="22,6 12,13 2,6" />
        </svg>
    )

    const renderIcon = (id, isActive) => {
        if (id === "status") return <CalendarIcon active={isActive} />
        if (id === "trends") return <TrendingUpIcon active={isActive} />
        if (id === "complaint") return <MailIcon active={isActive}/>
        return null
    }

    return(
        <NavWrap>
            <div className="inner">
                {navItems.map((item) => {
                    const isActive = item.id === currentPage

                    return (
                        <Link className={`nav-menu${isActive ? " active" : ""}`} key={item.id} to={item.href}>
                            {renderIcon(item.id, isActive)}
                            <span className="nav-label">
                                {item.label}
                            </span>

                            {isActive && (
                                <span className="active-bar" />
                            )}
                        </Link>
                    )
                })}
            </div>
        </NavWrap>
    )
}

const NavWrap = styled.div`
    z-index:99;
    position:fixed;
    left:0;
    bottom:0;
    width:100vw;
    background:#fff;
    border-top:1px solid #e5e7eb;
    box-shadow: 0 -4px 6px -1px rgba(0, 0, 0, .1);
  
    .inner {
      display:flex;
      justify-content: space-around;
      align-items:center;
      height:65px;
      padding:0 10px;
      
      .nav-menu {
        position:relative;
        flex:1;
        height:100%;
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap:5px;
        color:#6B7280;
        transition: all .2s ease;
        
        .nav-label {
          font-size:14px;
          font-weight:400;
        }
        
        &.active {
          color:#0072B9;
          
          .nav-label {
            font-weight:600;
          }
        }
        
        .active-bar {
          position:absolute;
          bottom:0;
          width:50px;
          height:2px;
          background:#0072B9;
          border-radius:9999px;
        }
      }
    }
`